<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="MES执行实时监测"></chart-title>
    <el-row id="center_5">
      <el-col :span="7">
        <div class="circlr_item">
          <div class="circlr_user">
            <i class="el-icon-user-solid"></i>
          </div>
          <span class="user_name">张三丰</span>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="circlr_item">
          <div class="circlr_sb">设备：270-1</div>
        </div>
      </el-col>
      <el-col :span="10"
        ><div class="circlr_item_text">
          <p>今日完成：152 EMS</p>
          <p>正在执行：8 EMS</p>
          <p class="success_tips">恭喜！执行任务中无延期</p>
          <p class="warn_tips">注意！执行任务中有即将延期</p>
          <p class="err_tips">警戒！执行任务中有已延期</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "center_5",
  components: { ChartTitle },
  data() {
    return {};
  },
  props: {},
  created() {},
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 25vh;
  #center_5 {
    height: calc(100% - 30px);
    padding: 0 30px;

    .circlr_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 100%;
      .circlr_user {
        font-size: 70px;
        color: #777777;
        border: 6px solid #777777;
        border-radius: 50%;
        height: 100px;
        width: 100px;
        line-height: 100px;
        text-align: center;
      }
      .user_name {
        color: #EBEEF5;
        margin-left: 10px;
      }
      .circlr_sb {
        color: #EBEEF5;
        font-size: 14px;
        border: 1px solid #777777;
        padding: 6px 12px;
      }
    }
    .circlr_item_text {
      height: 100%;
      color: #EBEEF5;
      display: flex;
      flex-direction: column;
      justify-content: center;
      p {
        margin-bottom: 10px;
      }
      .success_tips {
        color: #9bfb84;
      }
      .warn_tips {
        color: #fffb95;
      }
      .err_tips {
        color: #f56c6c;
      }
    }
  }
}
</style>